// @flow
import type { ProductType } from "../../types/product.js";

const setQuantityToOne = (products: Array<ProductType>): Array<ProductType> => {
  products.forEach(product => {
    product.quantity = 1;
  });
  return products;
};

export async function fetchProductData(
  productIds: number[]
): Promise<Array<ProductType>> {
  const data = await (await window.fetch(
    `/wishlist/public/service/wishlist?productCodes=${productIds.join(",")}`
  )).json();

  return setQuantityToOne(data.products);
}
